import { render, staticRenderFns } from "./OnDemandStartsPerReferrer.vue?vue&type=template&id=63b972be&scoped=true&"
import script from "./OnDemandStartsPerReferrer.vue?vue&type=script&lang=js&"
export * from "./OnDemandStartsPerReferrer.vue?vue&type=script&lang=js&"
import style0 from "./OnDemandStartsPerReferrer.vue?vue&type=style&index=0&id=63b972be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b972be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle})
